import React from "react";
import mediaBanner from "../../assets/media-banner.png";

export default function HeroNews() {
  return (
    <div className="w-full select-none">
      {/* Hero Banner Container */}
      <div
        className="w-full h-[250px] sm:h-[350px] md:h-[500px] lg:h-[580px] bg-cover bg-center relative"
        style={{ backgroundImage: `url(${mediaBanner})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/10"></div>
      </div>
    </div>
  );
}
